import { c as _c } from "react/compiler-runtime";
import { TabsWithRoutes } from "@components/common/tabs/tabs-with-routes";
import { useAppSelector } from "@store/store-helper";
import { MemberOverviewPage } from "@pages/profile/member-overview-page";
import { MemberTabs } from "@router/route-params";
import { generateTeamDetailsRoute, useAppParams } from "@router/router-helper";
import { useCompanyId } from "@context-providers/company-id-provider";
import { NotFoundPage } from "@pages/not-found-page";
import { fetchingMembersFlagsSelector } from "@store/members/members-selector";
import { companyMemberSelector } from "@store/members/members-selector";
import { Navigate } from "react-router-dom";
import { OpenTabEvents } from "@utils/track-event/track-event-list";
import { TEAMS_DISPLAY_NAME } from "@constants/team-constants";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { MemberTeamsPage } from "@pages/profile/member-teams-page";
import { fetchCompanyMemberDetails } from "@store/members/members-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
import { useEffect } from "react";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { RequiredRoleCompanyLevelName } from "@utils/access-control/company/company-access-control-types";

/**
 * Content in the member page
 */
export function MemberPage() {
  const $ = _c(34);
  const {
    memberTabs,
    memberId
  } = useAppParams();
  const companyId = useCompanyId();
  const dispatch = useAppDispatch();
  let t0;
  if ($[0] !== memberId) {
    t0 = companyMemberSelector(memberId);
    $[0] = memberId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const companyMember = useAppSelector(t0);
  const {
    isFetchingCompanyMemberDetails
  } = useAppSelector(fetchingMembersFlagsSelector);
  const {
    canViewTeams
  } = useHasUserValidRoleCompanyLevel();
  let t1;
  if ($[2] !== companyId || $[3] !== dispatch || $[4] !== memberId) {
    t1 = () => {
      if (memberId) {
        dispatch(fetchCompanyMemberDetails({
          companyId,
          identity: memberId
        }));
      }
    };
    $[2] = companyId;
    $[3] = dispatch;
    $[4] = memberId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== companyId || $[7] !== dispatch || $[8] !== memberId || $[9] !== memberTabs) {
    t2 = [companyId, dispatch, memberId, memberTabs];
    $[6] = companyId;
    $[7] = dispatch;
    $[8] = memberId;
    $[9] = memberTabs;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  useEffect(t1, t2);
  if (!memberTabs || !Object.values(MemberTabs).includes(memberTabs)) {
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <NotFoundPage />;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  if (!companyMember && !isFetchingCompanyMemberDetails) {
    let t3;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <NotFoundPage />;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    return t3;
  }
  if (companyMember && FaroCoreApiUtils.Member.isTeam(companyMember)) {
    let t3;
    if ($[13] !== companyId || $[14] !== companyMember.identity) {
      t3 = generateTeamDetailsRoute(companyId, companyMember.identity);
      $[13] = companyId;
      $[14] = companyMember.identity;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    let t4;
    if ($[16] !== t3) {
      t4 = <Navigate to={t3} replace={true} />;
      $[16] = t3;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    return t4;
  }
  let t3;
  if ($[18] !== isFetchingCompanyMemberDetails) {
    t3 = user => <MemberOverviewPage member={user} isLoading={isFetchingCompanyMemberDetails} />;
    $[18] = isFetchingCompanyMemberDetails;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <MemberOverviewPage member={null} isLoading={true} />;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== t3) {
    t5 = {
      label: "Overview",
      route: MemberTabs.overview,
      content: t3,
      loadingContent: t4
    };
    $[21] = t3;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = capitalizeFirstLetter(TEAMS_DISPLAY_NAME);
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MemberTeamsPage />;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  const t8 = !canViewTeams;
  let t9;
  if ($[25] !== t8) {
    t9 = {
      label: t6,
      route: MemberTabs.teams,
      content: _temp,
      loadingContent: t7,
      requiredRoleCompanyLevel: RequiredRoleCompanyLevelName.canViewTeams,
      isHidden: t8
    };
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t5 || $[28] !== t9) {
    t10 = [t5, t9];
    $[27] = t5;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== companyMember || $[31] !== memberTabs || $[32] !== t10) {
    t11 = <TabsWithRoutes selectedTab={memberTabs} dataTestId="MEMBER_PAGE_CONTAINER" trackingEventPageName={OpenTabEvents.openMemberAccountTab} requiredAttribute={companyMember} tabs={t10} />;
    $[30] = companyMember;
    $[31] = memberTabs;
    $[32] = t10;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
}
function _temp() {
  return <MemberTeamsPage />;
}